import { GetterTree } from "vuex";
import { Rapport, RapportFav } from "../../shared/Rapport";
import { RootState } from "../types";
import { RapportState } from "./types";
import { Site } from "@/shared/Site";

export const getters: GetterTree<RapportState, RootState> = {
  allReports(state) {
    if (state.allReports && state.allReports.length > 0) {
      return state.allReports;
    } else if (localStorage.allReports !== undefined) {
      state.allReports = JSON.parse(localStorage.allReports);
    }
    return state.allReports;
  },
  metrics(state) {
    if (state.metrics && Object.keys(state.metrics).length > 0) {
      return state.metrics;
    } else if (localStorage.metrics !== undefined) {
      state.metrics = JSON.parse(localStorage.metrics);
    }
    return state.metrics;
  },
  rapport(state): Rapport {
    if (state.rapport) {
      return state.rapport;
    } else {
      return new Rapport();
    }
  },
  favoris(state): RapportFav[] {
    if (state.favoris && state.favoris.length > 0) {
      return state.favoris;
    } else if (
      localStorage.favoris !== null &&
      localStorage.favoris !== undefined
    ) {
      state.favoris = JSON.parse(localStorage.favoris);
    } else {
      state.favoris = new Array();
    }
    return state.favoris;
  },
  selectedFavoris(state): RapportFav | undefined {
    // console.log("get get");
    if (!state.isNewFav && state.selectedFavoris !== "") {
      const sFav = state.favoris.find(
        (rap) => rap.id === state.selectedFavoris
      );

      if (sFav !== undefined) {
        state.isNewFav = false;
        return sFav;
      }
    } else {
      if (state.isNewFav) {
        return state.newFav;
      }
      return new RapportFav();
    }
  },
  isNewFavoris(state): boolean {
    return state.isNewFav;
  },
  lSites(state): Site[] {
    if (state.rapport) {
      return state.rapport.lSites;
    } else {
      return new Array();
    }
  },
};
